<template>
  <div>
    <v-layout align-end row wrap v-if="$cart.country.id" mt-4>
      <v-flex py-0 class="headline total-amount">{{ $t('CART.TOTAL_SUM') }}</v-flex>
      <v-flex py-0 class="font-weight-regular" text-xs-right>
        <span class="headline total-amount">{{ cartDetails.total.amount || "-" }}</span>
      </v-flex>
    </v-layout>
    <div class="text-xs-right">
      <span class="body-1">
        <span class="text-lowercase">({{ $t('CART.INCLUDE') }}</span>
        {{ $t('CART.VAT')}} {{ cartDetails.total.vat_amount }})
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cartDetails"]
};
</script>

<style lang="scss" scoped>
.total-amount {
  font-size: 26px !important;
  font-weight: 500;

  @media only screen and (max-width: 464px) {
    font-size: 26px !important;
  }
  @media only screen and (max-width: 426px) {
    font-size: 20px !important;
  }
  @media only screen and (max-width: 344px) {
    font-size: 16px !important;
  }
}
</style>
